export const UIColors = {
    backgroundDefault: "#1791CF",
    backgroundSecondary: "#99D9F3",
    backgroundNew: "#5C93CB",
};